export default "__VITE_ASSET__DrRwXfrc__"